import { Typography, Box, Button } from "@mui/material";
import Layout from "../../../components/Layout";
import styles from "../../index.module.scss";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import TableComponent from "../../../components/TableComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState, appActions } from "../../../store/app";
import AddIcon from "@mui/icons-material/Add";
import Storage from "../../../utils/storage";
import LoadingContainer from "../../../components/LoadingContainer";
import { useTranslation } from "../../../i18n";
import PopupMenu from "../../../components/PopupMenu";
import ConfirmModal from "../../../components/ConfirmModal";
import { deleteAction } from "../../../store/app/appActions";
import SearchComponent from "../../../components/SearchComponent";
import ChipComponent, { ChipData } from "../../../components/ChipComponent";
import { LoadingButton } from "@mui/lab";
import {
  exportReproductionAction,
  getReproductionsAction,
  searchReproductionAction,
} from "../../../store/pig/reproduction/reproductionActions";
import {
  Reproduction,
  reproductionColumns,
  ReproductionRow,
} from "../../../interfaces/Pig/reproduction";
import AddReproduction from "./AddReproduction";
import FilterReproduction from "./FilterReproduction";
import ReproductionView from "./ReproductionView";
import { deleteReproductionService } from "../../../store/pig/reproduction/reproductionService";
import { liveStockActions, LiveStockState } from "../../../store/pig";
import moment from "moment";

const Reproductions = () => {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [query, setQuery] = useState("");
  const [isInit, setIsInit] = useState(true);
  const dispatch = useDispatch();
  const appState: AppState = useSelector((state: any) => state.app);
  const liveStockState: LiveStockState = useSelector(
    (state: any) => state.liveStock
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [chipData, setChipData] = useState([]);
  const [reproduction, setReproduction] = useState<any>();
  const [viewReproduction, setViewReproduction] = useState<boolean>();
  const open = Boolean(anchorEl);
  const token = Storage.getToken();
  const { t } = useTranslation();
  
  useEffect(() => {
    if (!liveStockState.fetchedReproduction) {
      dispatch(
        getReproductionsAction(
          `?page=${page}&sort=-createdAt&limit=${rowsPerPage}&born=false&${query}`,
          token
        )
      );
    }
  }, [
    dispatch,
    liveStockState.fetchedReproduction,
    page,
    query,
    rowsPerPage,
    token,
  ]);

  useEffect(() => {
    if (!appState.isFetching) {
      setCount(appState.count);
    }
  }, [appState.isFetching, appState.count]);

  useEffect(() => {
    if (chipData.length > 0) {
      let queryString = "";
      chipData.forEach((data: any) => {
        queryString += `&${data.id}=${data.filter}`;
      });
      setQuery(queryString);
      dispatch(liveStockActions.setFetchedReproduction(false));
    } else if (chipData.length === 0 && query !== "") {
      setQuery("");
      dispatch(liveStockActions.setFetchedReproduction(false));
    }
  }, [chipData, dispatch, query]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (searchText) {
        dispatch(searchReproductionAction(`?text=${searchText}`, token));
        setIsInit(false);
      } else {
        if (!appState.isFetching && !isInit) {
          dispatch(liveStockActions.setFetchedReproduction(false));
        }
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [appState.isFetching, dispatch, isInit, searchText, token]);

  const createData = (reproduction: Reproduction): ReproductionRow => {
    return {
      sow: reproduction?.sow?.earTag,
      boar: reproduction?.boar?.earTag,
      date: reproduction?.date?.substring(0, 10),
      reproductionType: t(`${reproduction?.reproductionType}`),
      days: -moment(reproduction?.date?.substring(0, 10)).diff(
        moment.now(),
        "days"
      ),
      action: (
        <button
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setReproduction(reproduction);
            setAnchorEl(event.currentTarget);
          }}
          className={styles.actionsIcon}
        >
          •••
        </button>
      ),
    };
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(liveStockActions.setFetchedReproduction(false));
  };

  const filterHandler = (filterData: any) => {
    setChipData(filterData);
  };

  const handleChipDelete = (chipToDelete: ChipData) => {
    setChipData((chips) =>
      chips.filter((chip: ChipData) => chip.key !== chipToDelete.key)
    );
  };

  const exportExcelHandler = () => {
    dispatch(exportReproductionAction("?limit=1000", token, t("reproduction")));
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(liveStockActions.setFetchedReproduction(false));
  };

  const deleteReproductionHandler = () => {
    dispatch(
      deleteAction(
        deleteReproductionService,
        reproduction?._id,
        token,
        t("reproduction"),
        () => {},
        () => dispatch(liveStockActions.setFetchedReproduction(false))
      )
    );
  };

  // console.log(">>>>>>>>>>>>>>>>>>> ",`?page=${page}&sort=-createdAt&limit=${rowsPerPage}&born=false`,  liveStockState.reproduction);

  const rows = liveStockState.reproduction?.map((reproduction: Reproduction) =>
    createData(reproduction)
  );

  return (
    <>
      <Box className={styles.topContainer}>
        <Box>{t("welcome")}</Box>
        <Box className={styles.dFlex}>
          <SearchComponent setSearchText={setSearchText} />
          <LoadingButton
            variant="contained"
            startIcon={<SaveAltIcon />}
            loading={appState.isExportingExcel}
            onClick={exportExcelHandler}
            className={styles.exportExcelButton}
          >
            {t("exportExcel")}
          </LoadingButton>
        </Box>
      </Box>
      {appState.isFetching && <LoadingContainer />}
      {!appState.isFetching && (
        <>
          {chipData.length > 0 && (
            <ChipComponent
              chipData={chipData}
              handleDelete={handleChipDelete}
            />
          )}
          <Box className={styles.tableTopActions}>
            <Box>
              <Typography>{t("reproduction")}</Typography>
            </Box>
            <Box>
              <Button
                onClick={() => dispatch(appActions.setOpenFilter(true))}
                startIcon={<AddIcon />}
              >
                {t("filter")}
              </Button>
              <Button
                onClick={() =>
                  dispatch(
                    appActions.setOpenForm({ open: true, action: "add" })
                  )
                }
                startIcon={<AddIcon />}
              >
                {t("addNew")}
              </Button>
            </Box>
          </Box>
          <TableComponent
            rows={rows}
            columns={reproductionColumns}
            count={count}
            page={page}
            rowsPerPage={rowsPerPage}
            handlePageChange={handlePageChange}
            handleRowsPerPageChange={handleRowsPerPageChange}
          />
          {open && (
            <PopupMenu
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              onView={() => setViewReproduction(true)}
              onUpdate={() =>
                dispatch(
                  appActions.setOpenForm({ open: true, action: "update" })
                )
              }
              onDelete={() => dispatch(appActions.setIsDeleting(true))}
            />
          )}
          {appState.isDeleting && (
            <ConfirmModal
              onConfirm={() => deleteReproductionHandler()}
              content={`${t("confirmDeleteDesc")} ${
                reproduction?.boar?.earTag
              } ${reproduction?.sow?.earTag} ?`}
            />
          )}
          {appState.openForm.open && (
            <AddReproduction reproduction={reproduction} />
          )}
          {appState.openFilter && (
            <FilterReproduction
              open={appState.openFilter}
              close={() => dispatch(appActions.setOpenFilter(false))}
              filterHandler={filterHandler}
            />
          )}
          {viewReproduction && (
            <ReproductionView
              open={viewReproduction}
              onClose={() => setViewReproduction(false)}
              reproduction={reproduction}
            />
          )}
        </>
      )}
    </>
  );
};

export default Reproductions;
